import { useEffect, useState } from 'react';
import { Button } from '../../../components/UI/Common/Admin/Button';

export const Filters = ({
  value,
  onChange,
  onReset,
}: {
  value: string;
  onChange: (value: string) => void;
  onReset: VoidFunction;
}) => {
  const [userValue, setUserValue] = useState(value);

  useEffect(() => {
    if (!userValue) onChange('');
  }, [userValue]);
  return (
    <div className="mb-6 bg-white rounded-lg shadow p-4">
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[300px]">
          <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-2">
            Поиск
          </label>
          <div className="relative">
            <input
              autoFocus
              id="search"
              type="search"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Введите запрос..."
              value={userValue}
              onChange={(e) => setUserValue(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onChange(userValue)}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                className="h-5 w-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Button type="button" variant="primary" onClick={() => onChange(userValue)}>
            Поиск
          </Button>
          <Button type="button" variant="secondary" onClick={onReset}>
            Сбросить
          </Button>
        </div>
      </div>
    </div>
  );
};
